<!-- Header -->
<h3 mat-dialog-title translate>
    Edit Topic
</h3>

<!-- Body -->
<mat-dialog-content>
    <form>
        <tyl-form-field label="Topic Name"
            style="width: 430px;">
            <input matInput
                #titleField
                [(ngModel)]="information.Title"
                type="text"
                name="topic name"
                id="topicNameField"
                maxlength="100"
                required />
        </tyl-form-field>
        <br />
        <tyl-checkbox *ngIf="V10" [checked]="information.Status == 'A'"
            (change)="setStatus()">
            Active
        </tyl-checkbox>
        <!-- For V10 there should be dropdown -->
        <tyl-form-field *ngIf="!V10" label="Status">
            <mat-select id="contentStatus" name="ContentStatus"
                        [(ngModel)]="information.Status">
                <mat-option id="contentStatusActive" value="A">Active</mat-option>
                <mat-option id="contentStatusInactive" value="I">Inactive</mat-option>
            </mat-select>
        </tyl-form-field>
    </form>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>